module.exports = __webpack_public_path__ + "media/images/kid/kid_avatar_05-5072c584efba9df6fb122085a3bd4739.png";